var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-container"},[_c('Heading',{attrs:{"level":"2","align":"center"}},[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.title'
      ))+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-a'
      ))+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-b'
      ))+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-c'
      ))+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-d'
      ))+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-e'
      ))+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-f'
      ))+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-g'
      ))+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-h'
      ))+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-i'
      ))+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-j'
      ))+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-k'
      ))+"\n  ")]),_c('ButtonBase',{attrs:{"variant":"primary","block":"","rounded":""},on:{"click":_vm.goToNext}},[_vm._v("\n    "+_vm._s(_vm.$t(
        'exchange.account.deposits-and-withdrawals-terms-and-conditions.accept'
      ))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }